<script>
    import Button from "../button/Button.svelte";
    import Steps from "../steps/Steps.svelte";
    import { GET_TRANSACTION_LINK } from "../../constants/constants";
    import Ring from "../ring/Ring.svelte";
    import { ethers } from "ethers";
    import { getContext } from "svelte";
    import { projectDetail, projectSaleDetails } from "../../store";
    

    const { close } = getContext("simple-modal");

    const TxStatus = {
        None: "None",
        AwaitingSignature: "AwaitingSignature",
        AwaitingConfirmation: "AwaitingConfirmation",
        Error: "Error",
    };

    const ApproveSteps = {
        Approve: "Approve",
        Complete: "Complete",
    };

    export let reserve, setApprovalValue;

    let activeStep = ApproveSteps.Approve,
        txStatus = TxStatus.None,
        txReceipt,
        errorMsg;

    const approve = async () => {
        if (reserve) {
            try {
                txStatus = TxStatus.AwaitingSignature;
                const tx = await reserve.erc20Contract.approve(
                    $projectSaleDetails.id,
                    ethers.constants.MaxUint256
                );
                txStatus = TxStatus.AwaitingConfirmation;
                txReceipt = await tx.wait();
                activeStep = ApproveSteps.Complete;
                setApprovalValue(true);
                txStatus = TxStatus.None;
            } catch (e) {
                errorMsg = e.message;
                if (errorMsg.length > 500) errorMsg = "Something went wrong";
                txStatus = TxStatus.Error;
            }
        }
    };
</script>

{#if txStatus === TxStatus.None}
    <div class="flex column-direction approved-modal">
        <Steps
            steps={["Approve", "Complete"]}
            {activeStep}
            fulfilledTextClass="text-gray-100"
            lineBorderClass="border-gray-400"
        />

        {#if activeStep === ApproveSteps.Approve}
            <span class="modal-title">
                Approve the sale contract to spend your {$projectSaleDetails.token.symbol}
            </span>
            <Button
                buttonClass={"submit-btn "}
                id="approved-modal-btn"
                on:click={approve}>Approve</Button
            >
        {/if}

        {#if activeStep === ApproveSteps.Complete}
            <span class="modal-title">Approval confirmed.</span>
            <span class="title">You can now purchase from this sale. </span>
            <a
                class="text-blue-400 underline"
                target="_blank"
                href={ GET_TRANSACTION_LINK($projectDetail.chain?.chain_id, txReceipt?.transactionHash) }
            >
                See transaction.
            </a>
            <Button
                id="okay-modal-btn"
                buttonClass={"submit-btn "}
                on:click={() => {
                    close();
                }}>Ok</Button
            >
        {/if}
    </div>
{/if}

{#if txStatus === TxStatus.AwaitingSignature}
    <div class="flex items-center">
        <Ring color="#fff" />
        <span class="text-lg">Awaiting signature...</span>
    </div>
{/if}

{#if txStatus === TxStatus.AwaitingConfirmation}
    <div class="flex items-center">
        <Ring color="#fff" />
        <span class="text-lg">Transaction confirming...</span>
    </div>
{/if}

{#if txStatus === TxStatus.Error}
    <div class="flex column-direction buy-modal items-center gap-y-5 p-6">
        <span class="modal-title">Something went wrong.</span>
        <span class="text-lg text-red-400">{errorMsg}</span>
    </div>
{/if}

<style>
    .approved-modal span.title {
        font-size: 18px;
        line-height: 22px;
        color: #fff;
        margin: 0 0 20px;
    }
    span.text-lg {
        color: #fff;
    }
    a.text-blue-400 {
        margin: 0 0 20px;
    }
</style>
